


















import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

@Component({
    components: {

    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class LayerController extends Vue 
{
    // レイヤーの重なり順を求める
    private get layer()
    {
        var result = 0;
        var document = this.$store.getters.document;
        var page = document.pageList[document.currentPageIndex];
        var surface = page.getSurface(document.isReverseSurface);
        var design = surface.getDesign(page.currentDesignPosition);
        if(design != null)
        {
            var currentLayer = design.currentLayer;
            if(currentLayer != null)
            {
                var allLayers = design.getAllLayers(false);
                for(var i = 0; i < allLayers.length; ++i)
                {
                    if(currentLayer == allLayers[i])
                    {
                        // 開始が1になるように +1 する
                        result = i + 1;
                        break;
                    }
                }
            }
        }

        return result;
    }

    // direction : up 上階層へ, down 下階層へ
    private onClick(direction : string)
    {
        this.$emit("doCommand", "orderLayer", { direction : direction });
    }
}
